export const paginateRentals = ({
  filteredRentals,
  RENTALS_PER_PAGE,
  setTotalRentalPages,
  currentPage,
  setCurrentPage,
}) => {
  if (!Array.isArray(filteredRentals)) return [];
  const calculatedTotalPages = Math.ceil(filteredRentals.length / RENTALS_PER_PAGE);
  setTotalRentalPages(calculatedTotalPages || 1); // Ensure at least 1 page

  if (currentPage > calculatedTotalPages) {
    setCurrentPage(1); // Reset to the first page if the current page exceeds total pages
  }

  // Get the paginated slice
  const paginatedRentals = filteredRentals.slice(
    (currentPage - 1) * RENTALS_PER_PAGE,
    currentPage * RENTALS_PER_PAGE
  );

  return paginatedRentals;
};
